<template>
  <v-tabs v-model="tabMenu">
    <v-tabs-slider color="primary"></v-tabs-slider>
    <v-tab @click="resetTab()">Plan</v-tab>
    <v-tab v-show="planReviewTab" @click="resetTab(2)">{{ ids.planNo !== 'new' ? 'Plan Info / Risk List' : 'New Package Plan' }}</v-tab>
    <v-tab v-show="riskReviewTab" @click="resetTab(3)">{{ ids.riskNo !== 'new' ? 'Risk Info / Risk Item List' : 'New Package Risk' }}</v-tab>
    <v-tab v-show="itemReviewTab" @click="resetTab(4)">{{ ids.itemNo !== 'new' ? 'Risk Item Info /Risk SubItem List' : 'New Package Risk Item' }}</v-tab>
    <v-tab v-show="subItemReviewTab">{{ ids.subItemNo !== 'new' ? 'Risk SubItem Info' : 'New Risk SubItem' }}</v-tab>
    <v-tab-item>
      <pkg-plan-list :fetchPlan="fetchPlan" :scheme="scheme" @doReview="doPlanReview" @doNew="doPlanNew"></pkg-plan-list>
    </v-tab-item>
    <v-tab-item>
      <pkg-plan-form :ids="ids" @resetTab="resetTab"></pkg-plan-form>
      <pkg-risk-list v-show="ids.planNo !== 'new'" :fetchRisk="fetchRisk" :ids="ids" @doReview="doRiskReview" @doNew="doRiskNew"></pkg-risk-list>
    </v-tab-item>
    <v-tab-item>
      <pkg-risk-form :ids="ids" @resetTab="resetTab"></pkg-risk-form>
      <pkg-risk-item-list v-show="ids.riskNo !== 'new'" :ids="ids" :fetchItem="fetchItem" @doReview="doItemReview" @doNew="doItemNew"></pkg-risk-item-list>
    </v-tab-item>
    <v-tab-item>
      <pkg-risk-item-form :ids="ids" @resetTab="resetTab"></pkg-risk-item-form>
      <pkg-risk-sub-item-list v-show="ids.itemNo !== 'new'" :ids="ids" :fetchSubItem="fetchSubItem" @doReview="doSubItemReview" @doNew="doSubItemNew"></pkg-risk-sub-item-list>
    </v-tab-item>
    <v-tab-item>
      <pkg-risk-sub-item-form :ids="ids" @resetTab="resetTab"></pkg-risk-sub-item-form>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import PkgPlanList from './list/PkgPlanList'
import PkgRiskList from './list/PkgRiskList'
import PkgRiskItemList from './list/PkgRiskItemList'
import PkgRiskSubItemList from './list/PkgRiskSubItemList'
import PkgPlanForm from './form/PkgPlanForm'
import PkgRiskForm from './form/PkgRiskForm'
import PkgRiskItemForm from './form/PkgRiskItemForm'
import PkgRiskSubItemForm from './form/PkgRiskSubItemForm'

export default {
  data() {
    return {
      tabMenu: 0,
      planReviewTab: false,
      riskReviewTab: false,
      itemReviewTab: false,
      subItemReviewTab: false,
      fetchPlan: false,
      fetchRisk: false,
      fetchItem: false,
      fetchSubItem: false,
      ids: {
        scheme: null,
        planNo: null,
        riskNo: null,
        itemNo: null,
        subItemNo: null
      }
    }
  },
  computed: {
    schemeMenu() {
      return this.$store.state.parameters.scheme.schemeMenu
    }
  },
  methods: {
    async resetTab(tab) {
      switch (tab) {
        case 4: {
          this.tabMenu = 3
          this.ids.subItemNo = null
          this.planReviewTab = true
          this.riskReviewTab = true
          this.itemReviewTab = true
          this.subItemReviewTab = false
          this.fetchPlan = false
          this.fetchRisk = false
          this.fetchItem = false
          this.fetchSubItem = true
          break
        }
        case 3: {
          this.tabMenu = 2
          this.ids.itemNo = null
          this.planReviewTab = true
          this.riskReviewTab = true
          this.itemReviewTab = false
          this.subItemReviewTab = false
          this.fetchPlan = false
          this.fetchRisk = false
          this.fetchItem = true
          this.fetchSubItem = false
          break
        }
        case 2: {
          this.tabMenu = 1
          this.ids.riskNo = null
          this.planReviewTab = true
          this.riskReviewTab = false
          this.itemReviewTab = false
          this.subItemReviewTab = false
          this.fetchPlan = false
          this.fetchRisk = true
          this.fetchItem = false
          this.fetchSubItem = false
          break
        }
        default: {
          this.tabMenu = 0
          this.ids.planNo = null
          this.planReviewTab = false
          this.riskReviewTab = false
          this.itemReviewTab = false
          this.subItemReviewTab = false
          this.fetchPlan = true
          this.fetchRisk = false
          this.fetchItem = false
          this.fetchSubItem = false
        }
      }
    },
    doPlanReview(data) {
      this.ids.scheme = this.scheme
      this.ids.planNo = data.planNo
      this.planReviewTab = true
      this.fetchPlan = false
      this.fetchRisk = true
      this.tabMenu = 1
    },
    doPlanNew() {
      this.ids.scheme = this.scheme
      this.ids.planNo = 'new'
      this.planReviewTab = true
      this.fetchPlan = false
      this.fetchRisk = false
      this.tabMenu = 1
    },
    doRiskReview(data) {
      this.ids.scheme = data.scheme
      this.ids.planNo = data.planNo
      this.ids.riskNo = data.riskNo
      this.planReviewTab = true
      this.riskReviewTab = true
      this.fetchPlan = false
      this.fetchRisk = false
      this.fetchItem = true
      this.tabMenu = 2
    },
    doRiskNew() {
      this.ids.riskNo = 'new'
      this.planReviewTab = true
      this.riskReviewTab = true
      this.fetchPlan = false
      this.fetchRisk = false
      this.fetchItem = false
      this.tabMenu = 2
    },
    doItemReview(data) {
      this.ids.itemNo = data.itemNo
      this.planReviewTab = true
      this.riskReviewTab = true
      this.itemReviewTab = true
      this.fetchPlan = false
      this.fetchRisk = false
      this.fetchItem = false
      this.fetchSubItem = true
      this.tabMenu = 3
    },
    doItemNew() {
      this.ids.itemNo = 'new'
      this.planReviewTab = true
      this.riskReviewTab = true
      this.itemReviewTab = true
      this.fetchPlan = false
      this.fetchRisk = false
      this.fetchItem = false
      this.fetchSubItem = false
      this.tabMenu = 3
    },
    doSubItemReview(data) {
      this.ids.subItemNo = data.subItemNo
      this.planReviewTab = true
      this.riskReviewTab = true
      this.itemReviewTab = true
      this.subItemReviewTab = true
      this.fetchPlan = false
      this.fetchRisk = false
      this.fetchItem = false
      this.fetchSubItem = false
      this.tabMenu = 4
    },
    doSubItemNew() {
      this.ids.subItemNo = 'new'
      this.planReviewTab = true
      this.riskReviewTab = true
      this.itemReviewTab = true
      this.subItemReviewTab = true
      this.fetchPlan = false
      this.fetchRisk = false
      this.fetchItem = false
      this.fetchSubItem = false
      this.tabMenu = 4
    }
  },
  components: {
    PkgPlanList,
    PkgPlanForm,
    PkgRiskList,
    PkgRiskForm,
    PkgRiskItemList,
    PkgRiskItemForm,
    PkgRiskSubItemList,
    PkgRiskSubItemForm
  },
  props: {
    scheme: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>
